<template lang="html">

  <header class="menu-open">

    <div class="h-top animated slideInDown">
      <router-link :class="'logo-ajusa -'+lang" to="/"></router-link>
      <div class="align-center flex">
        <a class="fa fa-youtube-play btn-youtube" href="https://www.youtube.com/@ajusahydrogentecnologies5070" target="_blank"></a>
        <template v-if="$route.name == 'productos'">
          <button :class="['icon-menu -blue', show_menu ? 'active' : '']" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </template>
        <template v-else>
          <button :class="['icon-menu', show_menu ? 'active' : '']" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </template>
      </div>



    </div>

    <nav :class="['overlay-menu', show_menu ? 'open' : '']">
      <div class="col-50 flex column justify-center">
        <ul class="menu">
          <li><router-link to="/">{{$t('enlaces.textos.inicio')}}</router-link></li>
          <li><router-link :to="$t('enlaces.ajusath')">{{$t('enlaces.textos.ajusath')}}</router-link></li>
          <li><router-link :to="$t('enlaces.tecnologia')">{{$t('enlaces.textos.tecnologia')}}</router-link></li>
          <li><router-link :to="$t('enlaces.productos')">{{$t('enlaces.textos.productos')}}</router-link></li>
          <li><router-link :to="$t('enlaces.proyectos')">{{$t('enlaces.textos.proyectos')}}</router-link></li>
          <li><router-link :to="$t('enlaces.contacto')">{{$t('enlaces.textos.contacto')}}</router-link></li>
        </ul>
        <ul class="redes flex row justify-start">
          <li><a class="fa-brands fa-x-twitter" href="https://twitter.com/Ajusa_TH?lang=es" target="_blank"></a></li>
          <li><a class="fa fa-youtube-play" href="https://www.youtube.com/@ajusahydrogentecnologies5070" target="_blank"></a></li>
        </ul>
      </div>
    </nav>
  </header>

</template>

<script lang="js">
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: 'app-header',
    props: [],
    mounted() {

      var altura = $(window).height();

      $(window).scroll(function (event) {

        var distancia = $(window).scrollTop();

        if (distancia >= 260) {
          $(".h-top").addClass('min');
          $(".menu-catalogo-h").attr('style', 'opacity:1');
        } else {
          $(".menu-catalogo-h").attr('style', 'opacity:0');
          if ($(".overlay-menu").hasClass('open') == false) {
            $(".h-top").removeClass('min');
          }
        }

      });
    },
    data() {
      return {
        show_menu: false,
      }
    },
    methods: {
      toggleMenu: function () {
        this.show_menu = !this.show_menu;
      }
    },
    watch: {
      '$route': function () {
        this.show_menu = false;
      }
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage'
      })
    }
  }
</script>

<style scoped>
  .redes li {
    margin-right: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue